export default __webpack_public_path__ + "static/media/안주1.d855fd17.jpg";